import React, { useState } from 'react'
import { BsCheck } from 'react-icons/bs';
import { GoCheck } from 'react-icons/go';
import style from './shareat.module.css'
function index(props) {
  const FBLink = `https://www.facebook.com/sharer/sharer.php?u=${encodeURI(
    props.linkToShare.trim().replace(/ /g, "-")
  )}`;

  const WhatsappLink = `https://wa.me?text=${encodeURI(props.linkToShare)}`;

  const linkedinLink = `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURI(
    props.linkToShare.trim().replace(/ /g, "-")
  )}`;

  const [copy, setCopy] = useState(false)
  const handleCopyLink = () => {
    navigator.clipboard.writeText(props.linkToShare);
    setCopy(true);
  };

  return (
    <div className={style.shareCard}>
        <span className={style.title}>{props.title}</span>
        <a href={FBLink} target="_blank">
          <img src={props.fb} alt="facebook" className={style.icon} />
        </a>
        <a href={WhatsappLink} target="_blank">
          <img src={props.wh} alt="whatssap" className={style.icon} />
        </a>
        <a href={linkedinLink}>
          <img src={props.in} alt="linkedin" className={style.icon} />
        </a>
        <a onClick={handleCopyLink} style={{cursor: 'pointer'}}>
          {!copy ? (
            <img src={props.copy} alt="copy" className={style.icon} />
          ):(
            <GoCheck size={28.33}/>
          )}
        </a>
    </div>
  )
}

export default index